export default {
    "Van Cranenbroek": "Van Cranenbroek",
    "Menu": "Menu",
    "What are you looking for?": "Que cherchez-vous?",
    "back": "retour",
    "Filtering": "Filtrage",
    "Clear all": "Tout effacer",
    "Show more": "Afficher plus",
    "Show less": "Afficher moins",
    "Price": "Prix",
    "to": "\u00e0",
    "Enter a correct value": "Entrez une valeur correcte",
    "Popularity": "Popularit\u00e9",
    "Newest": "Plus r\u00e9cent",
    "Yes": "Oui",
    "No": "Non",
    "Name (A-Z)": "Nom (A-Z)",
    "Name (Z-A)": "Nom (Z-A)",
    "Price (Ascending)": "Prix (Croissant)",
    "Price (Descending)": "Prix (D\u00e9croissant)",
    "Categories": "Cat\u00e9gories",
    "Apply": "Appliquer",
    "No products were found in this category.": "Aucun produit n'a \u00e9t\u00e9 trouv\u00e9 dans cette cat\u00e9gorie.",
    "Discount valid from {start} to {end}": "Remise valable du {start} au {end}",
    "More info": "Plus d'infos",
    "Subscribe to our newsletter": "Abonnez-vous \u00e0 notre newsletter",
    "Yes i subscribe!": "Oui je m'abonne!",
    "Click here": "Cliquer ici",
    "Follow us": "Suivez-nous",
    "Compare products": "Comparer les produits",
    "Compare": "Comparer",
    "Edit": "Modifier",
    "Change password": "Changer le mot de passe",
    "Contact information": "Informations de contact",
    "Personal information": "Informations personnelles",
    "Opening Hours": "Heures d'ouverture",
    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "Sunday": "Dimanche",
    "Coffee corner": "Coin caf\u00e9",
    "Extra information": "Informations suppl\u00e9mentaires",
    "Phone": "T\u00e9l\u00e9phone",
    "Special opening hours": "Heures d'ouverture sp\u00e9ciales",
    "No special opening hours": "Pas d'heures d'ouverture sp\u00e9ciales",
    "Subject to change. Deviating opening hours (holidays etc.) are listed below under Special opening hours.": "Sous r\u00e9serve de modifications. Les heures d'ouverture d\u00e9viantes (jours f\u00e9ri\u00e9s, etc.) sont indiqu\u00e9es ci-dessous sous Heures d'ouverture sp\u00e9ciales.",
    "E-mailadress": "Adresse e-mail",
    "Subject": "Sujet",
    "Select a subject": "S\u00e9lectionnez un sujet",
    "Store": "Magasin",
    "Stores": "Magasins",
    "No specific store": "Aucun magasin sp\u00e9cifique",
    "Question": "Question",
    "Fields marked with * are required.": "Les champs marqu\u00e9s d'un * sont obligatoires.",
    "Submit contact request": "Envoyer la demande de contact",
    "Addition": "Ajout",
    "Declaration of conformity": "D\u00e9claration de conformit\u00e9",
    "Download": "T\u00e9l\u00e9charger",
    "House number": "Num\u00e9ro de maison",
    "First name": "Pr\u00e9nom",
    "Last name": "Nom de famille",
    "Phone number": "Num\u00e9ro de t\u00e9l\u00e9phone",
    "The {_field_} field must be selected.": "Le champ {_field_} doit \u00eatre s\u00e9lectionn\u00e9.",
    "The subject field must be selected.": "Le champ sujet doit \u00eatre s\u00e9lectionn\u00e9.",
    "Your message has been sent": "Votre message a \u00e9t\u00e9 envoy\u00e9",
    "In Stock in {count} store(s)": "En stock dans {count} magasin(s)",
    "I accept": "J'accepte",
    "Valid until": "Valable jusqu'au",
    "Sort by": "Trier par",
    "Show store": "Afficher le magasin",
    "Chosen filters": "Filtres choisis",
    "Show {totalItems} results": "Afficher {totalItems} r\u00e9sultats",
    "Sidebar menu - Quick Access": "Menu lat\u00e9ral - Acc\u00e8s rapide",
    "Quick access to": "Acc\u00e8s rapide \u00e0",
    "Call": "Appeler",
    "Atmospheric image of": "Image d'ambiance de",
    "In stock": "En stock",
    "Specifications": "Sp\u00e9cifications",
    "There was a problem with the subscription: This email address is already subscribed.": "Il y a eu un probl\u00e8me avec l'abonnement : Cette adresse e-mail est d\u00e9j\u00e0 abonn\u00e9e.",
    "Thank you for your subscription.": "Merci pour votre abonnement.",
    "Choose your {option}": "Choisissez votre {option}",
    "Other variants": "Autres variantes",
    "Remove from wishlist": "Retirer de la liste de souhaits",
    "Select an option to show stock information": "S\u00e9lectionnez une option pour afficher les informations de stock",
    "Promotion till": "Promotion jusqu'au",
    "Out of stock": "En rupture de stock",
    "In stock in {count} store(s)": "En stock dans {count} magasin(s)",
    "Other Variants": "Autres variantes",
    "{count} items in stock": "{count} articles en stock",
    "Less then {count} items in stock": "Moins de {count} articles en stock",
    "Others also viewed": "Les autres ont \u00e9galement regard\u00e9",
    "Frequently asked questions": "Questions fr\u00e9quemment pos\u00e9es",
    "Most asked questions": "Questions les plus pos\u00e9es",
    "Where are you searching for?": "Que cherchez-vous?",
    "Search on subject": "Rechercher par sujet",
    "This is what we found": "Voici ce que nous avons trouv\u00e9",
    "Product description": "Description du produit",
    "Privacy checkbox is required": "La case de confidentialit\u00e9 est obligatoire",
    "We didn't found any results": "Nous n'avons trouv\u00e9 aucun r\u00e9sultat",
    "Sorry, we couldn't find anything based on your search. Please change your search request, or search by category for your question.": "D\u00e9sol\u00e9, nous n'avons rien trouv\u00e9 en fonction de votre recherche. Veuillez modifier votre demande de recherche ou rechercher par cat\u00e9gorie pour votre question.",
    "Contact": "Contact",
    "Complaints? We\u2019re here to help!": "Des plaintes? Nous sommes l\u00e0 pour vous aider!",
    "We\u2019re sorry to hear that you have a complaint. We will do our best to resolve this as soon as possible.": "Nous sommes d\u00e9sol\u00e9s d'apprendre que vous avez une plainte. Nous ferons de notre mieux pour r\u00e9soudre cela d\u00e8s que possible.",
    "Can we help you with something?": "Pouvons-nous vous aider avec quelque chose?",
    "Do you need a helping hand? We\u2019re here to help you with any questions you may have.": "Avez-vous besoin d'un coup de main? Nous sommes l\u00e0 pour vous aider avec toutes les questions que vous pourriez avoir.",
    "Drag your photo here or use the upload button": "Faites glisser votre photo ici ou utilisez le bouton de t\u00e9l\u00e9chargement",
    "SVG, PNG, JPG of GIF (max. 200mb)": "SVG, PNG, JPG ou GIF (max. 200mb)",
    "Uploaden": "T\u00e9l\u00e9charger",
    "Drop your foto here": "D\u00e9posez votre photo ici",
    "My favorites": "Mes favoris",
    "You have no products in your favorites yet.": "Vous n'avez pas encore de produits dans vos favoris.",
    "Low stock": "Attention : Stock tr\u00e8s limit\u00e9 - la disponibilit\u00e9 en magasin ne peut \u00eatre garantie.",
    "Store stock": "Stock en magasin",
    "Put on wishlist": "Ajouter \u00e0 la liste de souhaits",
    "Read more": "Lire la suite",
    "Search suggestions": "Suggestions de recherche",
    "Popular products": "Produits populaires",
    "Price descending": "Prix (D\u00e9croissant)",
    "Price ascending": "Prix (Croissant)"
}